// Same paymentToken shape as the Datacap / Heartland iframe token: { Token, Last4, ExpirationYear, ExpirationMonth, Brand }.
// Token is a Stripe id created in the browser with the publishable key only:
//   ctoken_... ConfirmationToken (new card / Add Card), pi_... / seti_... after 3DS.
// Card details are not exposed to the browser here; the backend reads them from Stripe.
export const stripePaymentToken = (token) => ({
    Token: token || '',
    Last4: '',
    ExpirationYear: '',
    ExpirationMonth: '',
    Brand: '',
})

const isStripeId = (token, prefix) => typeof token === 'string' && token.startsWith(prefix)

// Stripe fields of a payment request (permit purchase, permit request, reservation).
// After 3DS the backend reads the authenticated PaymentIntent from payment_intent_id.
// In a FormData request paymentToken goes as a JSON string (see appendStripeFields).
export const stripePaymentFields = (paymentToken) => ({
    gateway_type: 'stripe',
    paymentToken: stripePaymentToken(paymentToken?.Token),
    ...(isStripeId(paymentToken?.Token, 'pi_') ? { payment_intent_id: paymentToken.Token } : {})
})

// FormData requests: paymentToken as one JSON string (the backend json_decodes it)
export const appendStripeFields = (formPostData, paymentToken) => {
    const fields = stripePaymentFields(paymentToken)
    formPostData.append('gateway_type', fields.gateway_type)
    formPostData.append('paymentToken', JSON.stringify(fields.paymentToken))
    if (fields.payment_intent_id) {
        formPostData.append('payment_intent_id', fields.payment_intent_id)
    }
    return fields
}

// add-card-profile payload for Stripe (Payment Settings > Add Card).
// token: ctoken_... from a setup-mode Payment Element, or seti_... after 3DS on the SetupIntent.
// After 3DS the backend reads the authenticated SetupIntent from setup_intent_id.
export const stripeAddCardPayload = (token) => ({
    payment_type: 'credit_card',
    savePaymentMethod: true,
    gateway_type: 'stripe',
    paymentToken: stripePaymentToken(token),
    ...(isStripeId(token, 'seti_') ? { setup_intent_id: token } : {})
})
